// istatistikSuzgec.js — STATISTICS: FAALİYET TİPİ · DEP · DEST SÜZGEÇLERİ (31 Eki 2026)
//
// 🔑 Serkan (31 Eki 2026, Build 77 öncesi geri bildirim 5): *"bütün veriler ekranda süzülebilsin (ticari, ferry, general
//    aviation…)"* · *"dept dest ile filtreye de ekleyebilir miyiz"* — iki örnek de onaylandı ("Uygun" · "Uygun, eklensin").
// 🔑 TİP GÖREVİN BACAĞINDAN — gerçek planı ezer (FTL ile aynı kural, `bacakTipi`): bacağın kendi tipi, yoksa görevin.
//    Süzgeç KAYITTAKİ tipi gösterir, şirketin FTL hesap esasını (ALL SHT-FTL) değil — esas yalnız hesabı değiştirir.
//    · iPad uçuşu: `plan_id` → görevin `plan_ids`i (archive-flight yazar) → aynı `plan_id`li bacak. Görev bacağı yoksa
//      planın tipi (arşivin bacağa yazdığı tip de odur — `plandanBacakTipi`).
//    · kâğıt uçuş: `manual_flights.assignment_id` = `kagitAnahtari(görev)`; `seq` görevin kâğıt UÇUŞ bacakları içinde
//      1'den sıra (DH yok, iPad'den arşivlenmiş bacak yok — yazıcı ve EDIT `ucusYeri` ile aynı kural, `kagitBacagiMi`).
//    Tip okunamazsa (bacak yok, tipsiz, ya da ekibin görev kayıtları farklı tip söylüyor) uçuş HİÇBİR tipe sayılmaz —
//    ayrı kutuda sayılır (İlke 1: bilinmiyor ≠ AIR TAXI).
// 🔑 DEP / DEST: tablonun sütunlarıyla aynı — DEST inilen meydan (divertte gerçek varış). Seçenekler yüklenen
//    uçuşlardaki meydanlar, alfabetik.
import { supabase } from '../supabaseClient';
import { OPERATION_TYPES, bacakTipi } from './FTLEngine';
import { kagitAnahtari, kagitBacagiMi } from './kagitUcus';
import { SAYILI, hepsiniOku, okunamadiMi } from './kesikOkuma';

export const ucusDep = (f) => f?.departure_icao || f?.plans?.dep || '';
export const ucusDest = (f) => f?.destination_icao || f?.plans?.dest || '';

/** Süzgeç seçenekleri: verideki meydanlar, tekrarsız, alfabetik. */
export const meydanSecenekleri = (ucuslar, al) => [...new Set((ucuslar || []).map(al).filter(Boolean))].sort();

// `.in()` / `.overlaps()` parça parça — tek istekte yüzlerce kimlik URL sınırına dayanır (FTLPanel'in 200'lük dilimleri gibi).
const PARCA = 100;
const parcala = (dizi) => { const p = []; for (let i = 0; i < dizi.length; i += PARCA) p.push(dizi.slice(i, i + PARCA)); return p; };

export const GOREV_OKUMASI = 'CREW DUTIES — OPERATION TYPE (crew_duties)';
export const KAGIT_BACAK_OKUMASI = 'APP FLIGHTS OF PAPER DUTIES (archived_flights)';

/** Uçuşların görev kayıtlarını okur (iptal edilmiş görev hariç). `okuDenetim` = `okumaDenetimi`nin `oku`su — düşen ya da kesik
 *  okuma ekranın kutusuna ADIYLA yazılır; ekran yarım veriyle toplam göstermez.
 *  @returns {Promise<{ gorevler: object[], ucuslar: Record<string, object> }>} `ucuslar`: kâğıt görevlerin bacaklarından
 *  iPad'den arşivlenmiş (silinmemiş) olanlar — `kagitBacagiMi` onlara bakar. */
export async function ucusGorevleriniOku(ucuslar, customerId, okuDenetim) {
  // Aynı okuma parça parça yapılır; düşen ilk parça kutuya ADIYLA bir kez yazılır (her parça için ayrı satır olmasın).
  const yazilan = new Set();
  const oku = (ad, s) => {
    if (okunamadiMi(s)) { if (yazilan.has(ad)) return null; yazilan.add(ad); }
    return okuDenetim(ad, s);
  };
  const planIdleri = [...new Set((ucuslar || []).filter(f => !f.paperOfp && f.plan_id).map(f => String(f.plan_id)))];
  const anahtarlar = [...new Set((ucuslar || []).filter(f => f.paperOfp && f.kagit?.atama).map(f => String(f.kagit.atama)))];
  // İptal edilmiş görev okunmaz; şirket açıkça süzülür (süper admin RLS'e bırakılmaz). Sütunlar her okumada açık yazılır —
  // okuma nöbetçisi (OkumaSiniri) `id`nin geldiğini kaynakta denetler.
  const sirketle = (q) => (customerId ? q.eq('customer_id', customerId) : q).neq('status', 'cancelled');
  const sonuclar = await Promise.all([
    ...parcala(planIdleri).map(p => hepsiniOku(() => sirketle(supabase.from('crew_duties')
      .select('id,assignment_id,customer_id,status,operation_type,operation_type_source,sectors,plan_ids', SAYILI))
      .overlaps('plan_ids', p))),
    // Kâğıt kaydın anahtarı atama bağı, yoksa görevin kendi kimliği (`kagitAnahtari`) — ikisi de aranır.
    ...parcala(anahtarlar).map(p => hepsiniOku(() => sirketle(supabase.from('crew_duties')
      .select('id,assignment_id,customer_id,status,operation_type,operation_type_source,sectors,plan_ids', SAYILI))
      .in('assignment_id', p))),
    ...parcala(anahtarlar).map(p => hepsiniOku(() => sirketle(supabase.from('crew_duties')
      .select('id,assignment_id,customer_id,status,operation_type,operation_type_source,sectors,plan_ids', SAYILI))
      .in('id', p))),
  ]);
  const tekil = new Map();
  sonuclar.forEach(s => (oku(GOREV_OKUMASI, s) || []).forEach(d => tekil.set(d.id, d)));
  const gorevler = [...tekil.values()];

  const anahtarKumesi = new Set(anahtarlar);
  const bacakPlanlari = [...new Set(gorevler.filter(d => anahtarKumesi.has(String(kagitAnahtari(d))))
    .flatMap(d => (d.sectors || []).map(x => x?.plan_id).filter(Boolean).map(String)))];
  const af = await Promise.all(parcala(bacakPlanlari).map(p => hepsiniOku(() => supabase.from('archived_flights')
    .select('id,plan_id', SAYILI).in('plan_id', p).is('deleted_at', null))));
  const arsivli = {};
  af.forEach(s => (oku(KAGIT_BACAK_OKUMASI, s) || []).forEach(r => { arsivli[String(r.plan_id)] = r; }));
  return { gorevler, ucuslar: arsivli };
}

/** Uçuş kimliği → faaliyet tipi (`OPERATION_TYPES`'tan biri) ya da null (okunamadı). Saf fonksiyon. */
export function ucusTipleri(ucuslar, gorevler, arsivli = {}) {
  const ekle = (m, k, d) => { if (!m.has(k)) m.set(k, []); m.get(k).push(d); };
  const planGorevleri = new Map(), anahtarGorevleri = new Map();
  for (const d of gorevler || []) {
    for (const p of d.plan_ids || []) ekle(planGorevleri, String(p), d);
    const k = kagitAnahtari(d);
    if (k) ekle(anahtarGorevleri, String(k), d);
  }
  const tipler = new Map();
  for (const f of ucuslar || []) {
    let bulunan = [];
    if (f.paperOfp) {
      bulunan = (anahtarGorevleri.get(String(f.kagit?.atama)) || []).map(d => {
        const b = Number.isInteger(f.seq) ? (d.sectors || []).filter(x => kagitBacagiMi(x, arsivli))[f.seq - 1] : null;
        return b ? bacakTipi(b, d).operation_type : '';
      });
    } else if (f.plan_id) {
      const pid = String(f.plan_id);
      bulunan = (planGorevleri.get(pid) || []).map(d => {
        const b = (d.sectors || []).find(x => x && !x.deadhead && String(x.plan_id || '') === pid);
        return b ? bacakTipi(b, d).operation_type : '';
      });
    }
    let farkli = [...new Set(bulunan.filter(Boolean))];
    if (!farkli.length && !f.paperOfp && f.plans?.operation_type) farkli = [f.plans.operation_type];
    tipler.set(f.id, farkli.length === 1 && OPERATION_TYPES.includes(farkli[0]) ? farkli[0] : null);
  }
  return tipler;
}
